export default class ModAccordion {
  constructor() {
    this.moduleClass = '.accordion-item'
    this.$this = $(this.moduleClass)
    this.jsClassExpand = 'accordion-item--expanded'
    this.openOneClass = '.only-open-one'
    this.ariaExpanded = 'aria-expanded'
    this.animatingClass = 'animating'
    this.initializedClass = 'accordion-initialized'
    this.clsAccordionInner = '.accordion-item__inner'
    this.buttonAria = 'button[aria-expanded]'
  }

  handleToggle(elem) {
    const $moduleParents = $(elem).parents(this.moduleClass)
    const $content = this.findContent($(elem))

    const open = $(elem).attr(this.ariaExpanded).trim() === 'true'
    const isOnlyOpenOne = $moduleParents.parents().is(this.openOneClass)

    const animationDuration = 400
    if (isOnlyOpenOne) {
      this.deActivate($moduleParents.parent())
      $(elem)
        .addClass(this.animatingClass)
        .attr(this.ariaExpanded, `${!open}`)
        .addClass(this.jsClassExpand)
      if (!open) {
        $content
          .stop().animate({ height: $content.find(this.clsAccordionInner).outerHeight() }, animationDuration, () => {
            this.scrollToItem(elem)
          })
      } else {
        $(elem).removeClass(this.jsClassExpand)
        $content.stop().animate({ height: '0' }, animationDuration, () => {
          $(elem).removeClass(this.animatingClass)
        })
      }
    } else {
      $(elem)
        .addClass(this.animatingClass)
        .attr(this.ariaExpanded, `${!open}`)
        .toggleClass(this.jsClassExpand)

      if (!open) {
        $content
          .stop().animate({ height: $content.find(this.clsAccordionInner).outerHeight() }, animationDuration, () => {
            $(elem).removeClass(this.animatingClass)
            this.scrollToItem(elem)
          })
      } else {
        $content.stop().animate({ height: '0' }, animationDuration, () => {
          $(elem).removeClass(this.animatingClass)
        })
      }
    }
  }

  scrollToItem(elem) {
    const $item = $(elem).closest(this.moduleClass)
    if (!$item.length) return

    const styles = getComputedStyle(document.documentElement)
    const headerHeight = parseFloat(styles.getPropertyValue('--height-header')) || 0
    const announcementHeight = parseFloat(styles.getPropertyValue('--height-announcement')) || 0
    const offset = headerHeight + announcementHeight + 16

    const itemTop = $item.offset().top
    const currentScroll = $(window).scrollTop()

    if (itemTop - offset < currentScroll) {
      $('html, body').animate({ scrollTop: itemTop - offset - 200 }, 300)
    }
  }

  deActivate(element) {
    const $buttons = element.find(this.buttonAria)
    const animationDuration = 400

    $buttons.each((_i, elem) => {
      const $elem = $(elem)
      const contentEl = this.findContent($elem)

      $elem.attr('aria-expanded', 'false').removeClass(this.jsClassExpand)
      contentEl.stop().animate({ height: '0' }, animationDuration)
    })
  }

  findContent(btn) {
    const controlsId = btn.attr('aria-controls')
    return $(`#${controlsId}`)
  }

  addListeners(element) {
    element.on('click', `${this.buttonAria}`, (e) => {
      this.handleToggle(e.currentTarget)
    })

    element.on('keydown', `${this.buttonAria}`, (e) => {
      this.keydownEventListener(e, e.currentTarget)
    })

    element.addClass(this.initializedClass)
  }

  initFirstItem() {
    $('.only-open-one').each((_i, container) => {
      const $container = $(container)
      const openFirst = $container.data('open-first') !== false

      if (openFirst) {
        const $firstButton = $container.find(`.accordion-item:first-child ${this.buttonAria}`)
        const $firstContent = this.findContent($firstButton)

        if ($firstButton.length && $firstContent.length) {
          const innerHeight = $firstContent.find(this.clsAccordionInner).outerHeight()
          $firstContent.css('height', `${innerHeight}px`)
        }
      }
    })
  }

  keydownEventListener(event, element) {
    const key = event.keyCode

    switch (key) {
      case 32:
      case 13:
        event.preventDefault()
        this.handleToggle(element)
        break
      default:
        break
    }
  }

  init() {
    $(document).on('click', `${this.moduleClass} ${this.buttonAria}`, (e) => {
      this.handleToggle(e.currentTarget)
    })

    $(document).on('keydown', `${this.moduleClass} ${this.buttonAria}`, (e) => {
      this.keydownEventListener(e, e.currentTarget)
    })
    this.initFirstItem()

    window.reinitAccordion = () => {
      this.initFirstItem()
    }
  }

  reinitialize() {
    this.$this = $(this.moduleClass)
    this.initFirstItem()
  }
}

const accordionInstance = new ModAccordion()
accordionInstance.init()

window.ModAccordionInstance = accordionInstance
